export const SOURCE_TYPE_ITS_RAPID = 'itsrapid'
export const SOURCE_TYPE_PIXABAY = 'pixabay';
export const SOURCE_TYPE_BYNDER = 'bynder';
export const SOURCE_TYPE_SALSIFY = 'salsify';

// Only It's Rapid honours tagsQuery. /bynder/retrieve-assets never puts it in $options, and
// Pixabay/Salsify ignore it, so the filter would silently do nothing on those.
export const SOURCES_WITH_TAGS = [SOURCE_TYPE_ITS_RAPID];

export const EXTERNAL_SOURCE_TYPES = [
    SOURCE_TYPE_PIXABAY,
    SOURCE_TYPE_BYNDER,
    SOURCE_TYPE_SALSIFY,
];
